import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrgRoleDepartmentDetailsFragment = { id: string, name: string, key?: string | null, level?: number | null, trackId?: string | null, userCount?: number | null, responsibilityUserCount?: number | null, mindsetCount?: number | null, skillCount?: number | null, activityCount?: number | null };


export type OrgRoleDepartmentDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type TrackDepartmentDetailsFragment = { id: string, name: string, isAutomaticTrack: boolean, orgRoles?: Array<{ id: string, name: string, key?: string | null, level?: number | null, trackId?: string | null, userCount?: number | null, responsibilityUserCount?: number | null, mindsetCount?: number | null, skillCount?: number | null, activityCount?: number | null }> | null };


export type TrackDepartmentDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type TrachWithSubtrackDepartmentDetailsFragment = { id: string, name: string, isAutomaticTrack: boolean, childTracks?: Array<{ id: string, name: string, isAutomaticTrack: boolean, orgRoles?: Array<{ id: string, name: string, key?: string | null, level?: number | null, trackId?: string | null, userCount?: number | null, responsibilityUserCount?: number | null, mindsetCount?: number | null, skillCount?: number | null, activityCount?: number | null }> | null }> | null, orgRoles?: Array<{ id: string, name: string, key?: string | null, level?: number | null, trackId?: string | null, userCount?: number | null, responsibilityUserCount?: number | null, mindsetCount?: number | null, skillCount?: number | null, activityCount?: number | null }> | null };


export type TrachWithSubtrackDepartmentDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type DepartmentDetailsFragment = { id: string, name: string, description?: string | null, tracks?: Array<{ id: string, name: string, isAutomaticTrack: boolean, orgRoles?: Array<{ id: string, name: string, key?: string | null, level?: number | null, trackId?: string | null, userCount?: number | null, responsibilityUserCount?: number | null, mindsetCount?: number | null, skillCount?: number | null, activityCount?: number | null }> | null }> | null, parentTracks?: Array<{ id: string, name: string, isAutomaticTrack: boolean, childTracks?: Array<{ id: string, name: string, isAutomaticTrack: boolean, orgRoles?: Array<{ id: string, name: string, key?: string | null, level?: number | null, trackId?: string | null, userCount?: number | null, responsibilityUserCount?: number | null, mindsetCount?: number | null, skillCount?: number | null, activityCount?: number | null }> | null }> | null, orgRoles?: Array<{ id: string, name: string, key?: string | null, level?: number | null, trackId?: string | null, userCount?: number | null, responsibilityUserCount?: number | null, mindsetCount?: number | null, skillCount?: number | null, activityCount?: number | null }> | null }> | null };


export type DepartmentDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type DepartmentDetailsQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type DepartmentDetailsQuery = { department?: { id: string, name: string, description?: string | null, tracks?: Array<{ id: string, name: string, isAutomaticTrack: boolean, orgRoles?: Array<{ id: string, name: string, key?: string | null, level?: number | null, trackId?: string | null, userCount?: number | null, responsibilityUserCount?: number | null, mindsetCount?: number | null, skillCount?: number | null, activityCount?: number | null }> | null }> | null, parentTracks?: Array<{ id: string, name: string, isAutomaticTrack: boolean, childTracks?: Array<{ id: string, name: string, isAutomaticTrack: boolean, orgRoles?: Array<{ id: string, name: string, key?: string | null, level?: number | null, trackId?: string | null, userCount?: number | null, responsibilityUserCount?: number | null, mindsetCount?: number | null, skillCount?: number | null, activityCount?: number | null }> | null }> | null, orgRoles?: Array<{ id: string, name: string, key?: string | null, level?: number | null, trackId?: string | null, userCount?: number | null, responsibilityUserCount?: number | null, mindsetCount?: number | null, skillCount?: number | null, activityCount?: number | null }> | null }> | null } | null };

export const OrgRoleDepartmentDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment OrgRoleDepartmentDetails on OrgRoleType {
  id
  name
  key
  level
  trackId
  userCount
  responsibilityUserCount
  mindsetCount
  skillCount
  activityCount
}
    `;
export const TrackDepartmentDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment TrackDepartmentDetails on TrackType {
  id
  name
  isAutomaticTrack
  orgRoles {
    ...OrgRoleDepartmentDetails
  }
}
    `;
export const TrachWithSubtrackDepartmentDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment TrachWithSubtrackDepartmentDetails on TrackType {
  childTracks {
    ...TrackDepartmentDetails
  }
  ...TrackDepartmentDetails
}
    `;
export const DepartmentDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment DepartmentDetails on DepartmentType {
  id
  name
  description
  tracks {
    ...TrackDepartmentDetails
  }
  parentTracks {
    ...TrachWithSubtrackDepartmentDetails
  }
}
    `;
export const DepartmentDetailsDocument = /*#__PURE__*/ gql`
    query departmentDetails($id: String!) {
  department(filters: {id: $id}) {
    ...DepartmentDetails
  }
}
    ${DepartmentDetailsFragmentDoc}
${TrackDepartmentDetailsFragmentDoc}
${OrgRoleDepartmentDetailsFragmentDoc}
${TrachWithSubtrackDepartmentDetailsFragmentDoc}`;

export function useDepartmentDetailsQuery(options: Omit<Urql.UseQueryArgs<DepartmentDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<DepartmentDetailsQuery, DepartmentDetailsQueryVariables>({ query: DepartmentDetailsDocument, ...options });
};